import { render, staticRenderFns } from "./archiveDocumentList.vue?vue&type=template&id=891879d2&scoped=true&"
import script from "./archiveDocumentList.vue?vue&type=script&lang=js&"
export * from "./archiveDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./archiveDocumentList.vue?vue&type=style&index=0&id=891879d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891879d2",
  null
  
)

export default component.exports